import { ReactNode, Dispatch, SetStateAction } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { MultiSelectionContent } from './MultiSelectionContent';
import { MultiSelectionPickerContextProvider } from './MultiSelectionPickerContext';

const useStyles = makeStyles(
  theme => ({
    container: {
      border: `1px solid ${theme.palette.grey[300]}`,
      flex: 1,
      display: 'flex',
      overflow: 'hidden',
      [theme.breakpoints.down('sm')]: {
        minHeight: '500px',
      },
    },
  }),
  { name: 'PickerBox' },
);

export interface WbMultiSelectionPickerProps<T> {
  title?: string;
  selectedValues: T[];
  setSelectedValues: Dispatch<SetStateAction<T[]>>;
  setOpenParent?: Dispatch<SetStateAction<boolean>>;
  children: ReactNode;
  fetchAiData?: () => Promise<T[]>;
  contentHeight?: string;
  headerActions?: ReactNode;
  disableAll?: boolean;
  onChange?: (val: T[]) => void;
}

export function WbMultiSelectionPicker<T>(
  props: WbMultiSelectionPickerProps<T>,
) {
  const classes = useStyles();
  const {
    setOpenParent,
    selectedValues,
    setSelectedValues,
    children,
    title,
    fetchAiData,
    contentHeight,
    headerActions,
    disableAll,
    onChange,
  } = props;

  return (
    <Box className={classes.container}>
      <MultiSelectionPickerContextProvider<T>
        selectedValues={selectedValues}
        setSelectedValues={setSelectedValues}
        fetchAIData={fetchAiData}
        disableAll={disableAll}
        onChange={onChange}
      >
        <MultiSelectionContent
          title={title}
          setOpen={setOpenParent!}
          contentHeight={contentHeight}
          headerActions={headerActions}
        >
          {/* left content */}
          {children}
        </MultiSelectionContent>
      </MultiSelectionPickerContextProvider>
    </Box>
  );
}
